<template>

  <div class="all">
    <headercon></headercon>
    <div class="content">
      <el-carousel class="ban"
                   trigger="click"
                   indicator-position="none"
                   ref="car"
                   arrow="always"
                   :interval="5000000">
        <el-carousel-item v-for="(a, i) in goodsList"
                          :key="i">

          <div class="box">
            <div class="lun"
                 v-for="(item, i) in a"
                 :key="i">
              <div class="imgbox">
                <div class="boxwarp">
                  <img :src="item.image"
                       alt=""
                       class="img1">
                </div>
              </div>
              <div class="textbox">
                <p>{{item.name}}</p>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import headercon from './header'
// eslint-disable-next-line no-unused-vars
import { Carousel, CarouselItem } from 'element-ui'
export default {
  components: {
    headercon
  },
  data () {
    return {
      img: require('../assets/componylogo.png'),
      text: '首页',
      text1: '产品与服务',
      text2: '企业动态',
      text3: '资质荣誉',
      text4: '关于我们',
      goodsList: [],
      pageNum: 0,
      pageSize: 10000
    }
  },
  created () {
    this.setData()
  },
  methods: {
    getlist () {
      const url = this.HOST + '/openApi/honorList'
      const that = this
      let arr2 = []
      axios.get(url, { params: { prodId: this.prodId, pageNum: this.pageNum, pageSize: this.pageSize } })
        .then(function (response) {
          let arr = response.data.rows
          for (let b = 0; b < arr.length; b++) {
            if (arr.length !== 0) { arr2.push(arr[b]) }
          }
          console.log(arr)
          let count = Math.ceil(arr2.length / 3) // 有小数就整数部分加1
          for (let i = 0; i < count; i++) {
            let arr1 = []
            for (let j = 0; j < 3; j++) {
              if (i * 3 + j >= arr2.length) {
                break
              }
              let item = arr2[i * 3 + j]
              arr1.push(item)
            }
            if (arr1.length !== 0) {
              that.goodsList.push(arr1)
            }
          }
        })
        .catch(function (error) {
          console.log('11111111111' + error)
        })
    },
    setData () {
      this.pageNum = this.pageNum + 1
      this.prodId = this.$route.params.prodId
      this.getlist(this.$route.params.prodId, this.pageNum)
    },
    go () {
      this.$router.push({ path: '/aboutus' })
    }
  }
}
</script>

<style scoped lang="less">
.all {
  background: url("../assets/details.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1199px;
  .content {
    width: 100%;
    height: 70%;
    margin: 3% auto;
    .but1 {
      margin-top: 20%;
      margin-left: -10%;
      width: 8%;
      height: 25%;
      font-size: 50px;
      background: linear-gradient(to right, #d5edfb, #eeffff);
    }
    .but2 {
      margin-top: 20%;
      margin-right: -10%;
      width: 8%;
      height: 25%;
      font-size: 50px;
      background: linear-gradient(to right, #eeffff, #d5edfb);
    }
    .box {
      width: 80%;
      height: 100%;
      margin: 0 auto;
      justify-content: space-between;
      display: flex;
      .lun {
        width: 30%;
        height: 95%;
        margin: auto;
        border-radius: 20px;
        display: inline-block;
        background: linear-gradient(#eeffff, #d5edfb);
        .imgbox {
          width: 100%;
          height: 70%;
          .boxwarp {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .img1 {
              height: auto;
              width: 60%;
            }
          }
        }
        .textbox {
          width: 100%;
          height: 10%;
          background-image: url("../assets/yezi.png");
          background-size: 100% 100%;
          margin: 100px auto;
          text-align: center;
          p {
            width: 100%;
            color: #5255a1;
            line-height: 50px;
          }
        }
      }
    }
  }
  /deep/ .li4 {
    list-style-type: none;
    float: left;
    text-decoration: none;
    text-align: center;
    background: #fff;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border-radius: 25px;
    a {
      color: #757575;
      text-decoration: none;
    }
  }
}
@media only screen and (min-width: 1781px) {
  .lun {
    .textbox {
      p {
        font-size: 18px;
      }
    }
  }
}
@media only screen and (min-width: 1601px) and (max-width: 1780px) {
  .lun {
    .textbox {
      p {
        font-size: 17px;
      }
    }
  }
}
@media only screen and (min-width: 1421px) and (max-width: 1600px) {
  .lun {
    .textbox {
      p {
        font-size: 14px;
      }
    }
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1420px) {
  .lun {
    .textbox {
      p {
        font-size: 12px;
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
  .lun {
    .textbox {
      p {
        font-size: 11px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/honor.vue